import { Box, Typography, Stack } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  type LoyaltyEventCode,
  LoyaltyPointType,
} from "Infrastructure/Api/Api";
import { EVENT_TO_ICON, POINTS_RESOURCES } from "Components/Loyalty/EventUtils";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Loyalty.Events;

type Props = {
  event: LoyaltyEventCode;
  points: number;
  isCompleted?: boolean;
  loyaltyPointType?: LoyaltyPointType;
};

export const CompactChallenge = ({
  event,
  points,
  isCompleted,
  loyaltyPointType = LoyaltyPointType.Stardust,
}: Props) => {
  const { t } = useResource();

  return (
    <Box
      pr={2}
      pl={3}
      minHeight={40}
      borderLeft={8}
      display="flex"
      borderRadius={2}
      position="relative"
      alignItems="center"
      bgcolor="background.paper"
      boxShadow="0px 1px 4px 0px rgba(0, 0, 0, 0.15)"
      sx={{ borderLeftColor: isCompleted ? "success.main" : "grey.200" }}
    >
      <Box
        mr={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
        color={isCompleted ? "success.main" : "primary.main"}
        sx={{ "& svg": { fontSize: 24 } }}
      >
        {isCompleted ? <CheckCircleOutlineIcon /> : EVENT_TO_ICON[event]}
      </Box>
      <Box flex={1} mr={2}>
        <Stack gap={1} my={2}>
          <Typography
            variant="h6"
            component="h3"
            fontSize="1rem"
            fontWeight={400}
            lineHeight={1.2}
            color={isCompleted ? "success.main" : "primary.main"}
          >
            {t(RESOURCES[event].title)}
          </Typography>
          <Typography
            variant="body2"
            fontSize="0.875rem"
            color="text.secondary"
            lineHeight={1.2}
          >
            {t(RESOURCES[event].description)}
          </Typography>
        </Stack>
      </Box>
      <Box textAlign="right">
        <Typography
          variant="body2"
          fontWeight={400}
          fontSize="0.875rem"
          color="text.secondary"
        >
          +
          {t(POINTS_RESOURCES[loyaltyPointType], {
            count: points,
          })}
        </Typography>
      </Box>
    </Box>
  );
};
